import { r as registerInstance, h, g as getElement } from './index-aaa15b55.js';
import { l as lodash_throttle } from './index-52991519.js';
import { g as getLocalStore } from './index-4d2624c8.js';
import { q as escape } from './logger-faaf508a.js';

const fcisTooltipCss = "fcis-tooltip{height:24px}.fcis-tooltip__icon{width:24px;height:24px}.fcis-tooltip a{background-color:transparent;cursor:pointer;text-decoration:none;color:var(--wb-grey-20);outline-color:var(--wb-blue-45);color:var(--wb-blue-45);border-bottom:1px solid currentColor}.fcis-tooltip a.wb-link--theme-dark{outline-color:var(--wb-blue-50)}.fcis-tooltip a.wb-link--theme-dark{outline-color:var(--wb-blue-50)}.fcis-tooltip a:focus{outline-width:1px;outline-style:solid;outline-offset:5px}.fcis-tooltip a:hover,.fcis-tooltip a:focus{color:var(--wb-blue-25)}.fcis-tooltip:before{border-top-color:var(--wb-black) !important}.fcis-tooltip__content{background-color:var(--wb-black)}";

const FcisTooltip = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._throttledResize = lodash_throttle(this.onWindowResize.bind(this), 500);
  }
  componentDidLoad() {
    window.addEventListener('resize', this._throttledResize, false);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this._throttledResize, false);
  }
  /**
   * cleanDropdownFocus: Hide all dropdow result list
   * @returns {void}
   */
  cleanDropdownFocus() {
    document
      .querySelectorAll('.fcis-dropdown__input')
      .forEach((item) => {
      item.blur();
    });
  }
  /**
   * Removes tooltip focus when resizing
   */
  onWindowResize() {
    const tooltipHost = this.el.querySelector('.fcis-tooltip');
    tooltipHost.open && (tooltipHost.open = false);
  }
  /**
   * Use different position when MQ is set to 1
   */
  get tooltipPosition() {
    const { stretch, currentMQ } = getLocalStore(this.storeId);
    const horizontalPosition = stretch && this.positionStart ? 'start' : 'end';
    return currentMQ === 'MQ1' ? 'start' : horizontalPosition;
  }
  render() {
    return (h("wb-tooltip-host", { position: this.tooltipPosition, class: 'fcis-tooltip' }, h("wb-icon", { class: 'fcis-tooltip__icon', name: 'question-mark-outline', onMouseOver: () => this.cleanDropdownFocus() }), h("wb-tooltip", { class: 'fcis-tooltip__content' }, h("span", { innerHTML: escape(this.content) }))));
  }
  get el() { return getElement(this); }
};
FcisTooltip.style = fcisTooltipCss;

export { FcisTooltip as fcis_tooltip };
